// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_1i-6";
export var headerCell = "_1i-2";
export var rowWrapper = "_1i-4";
export var stickyAggregationCell = "_1i-a";
export var stickyAggregationRow = "_1i-7";
export var stickyColumnCell = "_1i-9";
export var stickyColumnHeaderCell = "_1i-8";
export var table = "_1i-1";
export var virtualRowWrapper = "_1i-5";
export var virtualTableContainer = "_1i-0";
export var white = "_1i-3";